<template>
    <div></div>
</template>

<script>
export default {
    name: "auth-check",
    mounted() {
        if(localStorage.getItem("token") == null){
            this.$router.push("signin")
        } else if(!this.$store.state.user) {
            this.axios.get(process.env.VUE_APP_API_URL + "user", {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("token")
                }
            }).then((resp) => {
                this.$store.commit('setUser', resp.data.user)
            }).catch(() => {
                this.$router.push('/signin')
            })
        }
    },
};
</script>
